module.exports = require("object-assign");


//////////////////
// WEBPACK FOOTER
// external "object-assign"
// module id = 42
// module chunks = 0